import { __awaiter } from 'tslib';
import axios from 'axios';
import baseV3Service from './base/baseV3Service.js';

const getSignedURL = (uploadType, config) => {
    return baseV3Service.get(`uploads/${uploadType}/signed-url`, config);
};
const uploadFileToPreSignedURL = (url, file, onUploadProgress) => __awaiter(void 0, void 0, void 0, function* () {
    const isImage = file.type.startsWith("image/");
    const headers = isImage && file.type ? { "Content-Type": file.type } : {};
    return axios(url, {
        method: "PUT",
        data: file,
        headers,
        onUploadProgress,
    })
        .then((response) => response.data)
        .catch((error) => {
        console.error("Error uploading file to pre-signed URL", error);
        throw error;
    });
});

export { getSignedURL, uploadFileToPreSignedURL };
